import type { SanityPageBuilderLinkBarsItem, SanityPageBuilderLinkBarsLink, SanityPageBuilderLinkBarsSection, SanityPageBuilderSection } from "@ouster/shared";
import { LinkBarsBlockView } from "~/features/blocks/inventory/link-bars";
import { LinkBarsItemView, type LinkBarsItemViewProps } from "~/features/blocks/inventory/link-bars/link-bars-item";
import { LinkBarsItemLinkView } from "~/features/blocks/inventory/link-bars/link-bars-item.link";
import { toCraftLinkArray } from "~/features/sanity/link";
import type { Mode, Theme } from "~/features/ui/get-theme-style";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderLinkBarsSection;
  };
};
type LinkBarsViewLink = {
  _key?: SanityPageBuilderLinkBarsLink["_key"];
  caption?: SanityPageBuilderLinkBarsLink["caption"];
  id?: string;
  link?: ReturnType<typeof toCraftLinkArray>;
};
type LinkBarsViewItem = Omit<LinkBarsItemViewProps<LinkBarsViewLink>, "count" | "mode" | "renderLink" | "theme"> & Pick<SanityPageBuilderLinkBarsItem, "_key">;
export function SanityLinkBarsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  const theme = (sectionSettings?.theme || "white") as Theme;
  const items = sectionContent.items?.map<LinkBarsViewItem>(item => ({
    _key: item._key,
    links: item.links?.map<LinkBarsViewLink>(link => ({
      _key: link._key,
      caption: link.caption,
      id: link._key,
      link: toCraftLinkArray(link.link)
    })) ?? [],
    title: item.title
  })) ?? [];
  return <LinkBarsBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getItemKey={(item, index) => item._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} items={items} mode={mode} renderItem={(item, _index, count) => <LinkBarsItemView count={count} getLinkKey={(link, index) => link._key || index} links={item.links} mode={mode} renderLink={link => <LinkBarsItemLinkView caption={link.caption} id={link.id} link={link.link} mode={mode} theme={theme} />} theme={theme} title={item.title} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={theme} />;
}